import React from "react"
import "./normalize.css"
import "./Fonts.css"
import "./Styles.css"

import Header from "./Header"
import Footer from "./Footer"

const GlobalLayout = ({children, pageContext }) => {
    return (
        <div className="globalLayout">
            <Header />
            {children}
            <Footer pageContext={ pageContext }/>
        </div>
    );
};

export default GlobalLayout;